import React from "react";
import {
  ThemeProvider,
  createTheme,
  StyledEngineProvider,
} from "@mui/material/styles";

const customTheme = createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          borderRadius: "50%",
          "&.Mui-selected": {
            backgroundColor: "#9C27B0",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#9C27B0",
            },
            "&:focus": {
              backgroundColor: "#9C27B0",
            },
          },
          "&:focus": {
            backgroundColor: "#F7EEF9",
          },
          "&:hover": {
            backgroundColor: "#F7EEF9",
          },
        },
      } as any,
    },
    MuiStaticDateRangePicker: {
      styleOverrides: {
        root: {
          borderRadius: "50%",
        },
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: {
          color: "#000000",
          "&:hover": {
            backgroundColor: "#F7EEF9",
          },
          "&.Mui-selected": {
            backgroundColor: "#9C27B0",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#9C27B0",
            },
            "&:focus": {
              backgroundColor: "#9C27B0",
            },
          },
          "&:focus": {
            backgroundColor: "#F7EEF9",
          },
        },
      },
    },
    MuiPickersMonth:{
      styleOverrides: {
        monthButton: {
          color: "#000000",
          "&:hover": {
            backgroundColor: "#F7EEF9",
          },
          "&.Mui-selected": {
            backgroundColor: "#9C27B0",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#9C27B0",
            },
            "&:focus": {
              backgroundColor: "#9C27B0",
            },
          },
          "&:focus": {
            backgroundColor: "#F7EEF9",
          },
        },
      },
    },
    MuiDateRangePickerDay: {
      styleOverrides: {
        rangeIntervalDayHighlight: {
          backgroundColor: "#f7eef9",
        },
      },
    },
  },
});

const CustomThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={customTheme}>{children}</ThemeProvider>
  </StyledEngineProvider>
);

export default CustomThemeProvider;
